import { Col, Container, Image, Row } from 'react-bootstrap';
import QuextionIcon from 'assets/img/landing/internetHub/question.svg';
import AssessmentIcon from 'assets/img/landing/internetHub/assessment.svg';
import EmployeeIcon from 'assets/img/landing/internetHub/employee-man.svg';
import MobileIcon from 'assets/img/landing/internetHub/mobile.svg';
import GraduationIcon from 'assets/img/landing/internetHub/graduation-cap.svg';
import ThumbsUpIcon from 'assets/img/landing/internetHub/thumbs-up.svg';
import { InterviewHubInfo, InterviewHubDetails } from './interviewhub.type';
import { LandingRole } from 'pages/landing/main.type';

const hubMapping: Record<LandingRole, InterviewHubDetails | null> = {
  student: {
    title: 'Unlock Your Tech Future with CRUDBeat',
    data: [
      {
        title: 'Launch Your Tech Journey',
        description:
          'Register through your college and get instant access.Start your tech career with ready-to-use login credentials.',
        icon: QuextionIcon
      },
      {
        title: 'Learn. Compete. Win.',
        description:
          'Participate in hackathons, coding contests, and tech projects.Win badges, rewards, and recognition in the global tech community.',
        icon: AssessmentIcon
      },
      {
        title: 'Get Certified & Shine',
        description:
          'Complete coding tests, assessments, and skill challenges.Receive globally acknowledged certificates that boost your resume.',
        icon: MobileIcon
      },
      {
        title: 'Connect with Top Recruiters',
        description:
          'Apply directly to global tech companies and startups.Unlock exclusive job opportunities through CRUD Beat’s platform.',
        icon: EmployeeIcon
      },
      {
        title: 'Track Your Career Progress',
        description:
          'Monitor your scores, assessments, and project progress.Access personalized career recommendations and job alerts.',
        icon: ThumbsUpIcon
      },
      {
        title: 'Shape Your Future with Expert Guidance ',
        description:
          'Join career-building workshops, tech bootcamps, and webinars.Receive personalized mentorship from industry-leading experts.',
        icon: GraduationIcon
      }
    ]
  },
  recruiter: {
    title:
      'Prepare, practice, and ace interviews with expert tips and resources.',
    data: [
      {
        title: 'Instant Talent Discovery',
        description:
          'Explore a global talent pool of pre-assessed candidates, using AI-driven matching for precise andefficient hiring.',
        icon: QuextionIcon
      },

      {
        title: 'Automated Skill Verification',
        description:
          'Candidates are pre-screened with coding assessmentsand real-world project evaluations. Focus only onthe best-qualified professionals.',
        icon: AssessmentIcon
      },
      {
        title: 'Smart Shortlisting',
        description:
          'Instantly shortlist top candidates based on skill scores and tech certifications. Save time with our advanced filtering system.',
        icon: MobileIcon
      },
      {
        title: 'Integrated Interview Scheduler',
        description:
          'Manage interview rounds with built-in calendar integration.Receive automated reminders and updates for smooth scheduling.',
        icon: EmployeeIcon
      },
      {
        title: ' Data-Driven Decision Making',
        description:
          'Make hiring decisions backed by detailed performance analytics. Compare candidates using real-timerecruitment insights.',
        icon: ThumbsUpIcon
      },
      {
        title: 'End-to-End Hiring Workflow',
        description:
          'Manage the entire recruitment process from one intuitive dashboard. Post jobs, review candidates, conductinterviews, and send offers – all in one platform.',
        icon: GraduationIcon
      }
    ]
  },
  college: {
    title:
      'Prepare, practice, and ace interviews with expert tips and resources.',
    data: [
      {
        title: 'Global Job Opportunities',
        description:
          'Provide direct access to global tech job openings.Help students land internships, co-op programs, and full-time positions. ',
        icon: QuextionIcon
      },
      {
        title: 'Skill Development & Certifications',
        description:
          'Enable students to participate in coding tests, assessments, and tech challenges. Award industry-recognized certificates for verified tech skills.',
        icon: AssessmentIcon
      },
      {
        title: 'Dedicated Placement Portal',
        description:
          'Manage on-campus placements through a centralized platform.Schedule recruitment drives and track student progress in real time.',
        icon: MobileIcon
      },
      {
        title: 'Hackathons & Tech Competitions',
        description:
          'Host college-wide or inter-college hackathons.Challenge students with real-world tech problems and build winning solutions.',
        icon: EmployeeIcon
      },
      {
        title: 'Industry Networking & Events',
        description:
          'Organize tech meetups, webinars, and career fairs.Connect students with industry leaders and hiring managers.',
        icon: ThumbsUpIcon
      },
      {
        title: 'Career Development Workshops',
        description:
          'Conduct career counseling, resume-building, and interview preparation sessions. Offer personalized mentorship from industry experts.',
        icon: GraduationIcon
      }
    ]
  },
  default: null
};

function InterviewHub({ role }: { role: LandingRole }) {
  const interviewHubDetails = hubMapping[role];
  return (
    <Container fluid className="p-lg-9 py-10">
      <p className="fs-5 fw-bold text-center leading-2">
        Interview Success Hub: Your One-Stop Solution
      </p>
      <p className="text-body-secondary text-center pb-5">
        {interviewHubDetails?.title}
      </p>

      <Row className="py-6 g-4">
        {interviewHubDetails?.data?.map(
          (info: InterviewHubInfo, index: number) => (
            <Col
              lg={4}
              sm={6}
              key={`card-${index}`}
              className="d-flex justify-content-center"
            >
              <div className="d-flex flex-column justify-content-start p-2 mb-2 gap-3">
                <div className="fs-7 fw-bold">{info?.title}</div>
                <div className="fs-8 text-body-tertiary">
                  {info?.description}
                </div>
                <div className="d-flex justify-content-start">
                  <div className="bg-body-highlight p-3 rounded">
                    <Image src={info?.icon} width={25} alt={info?.title} />
                  </div>
                </div>
              </div>
            </Col>
          )
        )}
      </Row>
    </Container>
  );
}

export default InterviewHub;
